import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

interface ConfirmDialogData {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
}

@Component({
  selector: 'app-confirm-dialog',
  template: `
    <div class="confirm-dialog">
      <h2 mat-dialog-title>{{ data.title }}</h2>

      <mat-dialog-content>
        <p>{{ data.message }}</p>
      </mat-dialog-content>

      <mat-dialog-actions>
        <button
          mat-button
          class="dialog-button"
          (click)="onCancel()"
        >
          {{ data.cancelText || 'Cancel' }}
        </button>
        <button
          mat-raised-button
          color="primary"
          class="dialog-button"
          (click)="onConfirm()"
        >
          {{ data.confirmText || 'Confirm' }}
        </button>
      </mat-dialog-actions>
    </div>
  `,
  styles: [
    `
      .confirm-dialog {
        min-width: 300px;
        max-width: 500px;
      }

      mat-dialog-content {
        margin: 20px 0;
      }

      p {
        margin: 0;
        color: rgba(0, 0, 0, 0.87);
        font-size: 16px;
        line-height: 1.5;
      }

      mat-dialog-actions {
        padding: 16px;
        margin-bottom: 0;
        display: flex;
        justify-content: flex-end;
        gap: 12px;
      }

      .dialog-button {
        min-width: 90px;
        padding: 16px;
        height: 36px;
        line-height: 36px;
      }
    `,
  ],
})
export class ConfirmDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData,
  ) {}

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
